// this shim uses momentjs for the date/time parsing of the picker instead of 
// its custom date/time formats which are awful
$.datepicker.parseDate = function (format, value) {
    if (value === "" || value === null) {
        return moment().toDate();
    }
    return moment(value, format).toDate();
};
$.datepicker.formatDate = function (format, value) {
    if (value === "" || value === null) {
        return moment().format(format);
    }
    return moment(value).format(format);
};
